import http from "../../plugins/axios";

export default {
  queryCouponInfo(data) {
    return http.get({
      url: "/admin/coupon/list",
      data,
    });
  },
  addCoupon(data) {
    return http.post({
      url: "/admin/coupon/add",
      data,
      dataType: "form",
    });
  },
  getMortgageConfig(data) {
    return http.get({
      url: "/admin/mortgage/getConfig",
      data,
    });
  },

  mortgageOpen(data) {
    return http.post({
      url: "/admin/mortgage/open",
      data,
      dataType: "form",
    });
  },
  mortgageCountLimit(data) {
    return http.post({
      url: "/admin/mortgage/countLimit",
      data,
      dataType: "form",
    });
  },
  mortgageRiskStep(data) {
    return http.post({
      url: "/admin/mortgage/riskStep",
      data,
      dataType: "form",
    });
  },
  mortgageOperation(data) {
    return http.post({
      url: "/admin/mortgage/operation",
      data,
      dataType: "form",
    });
  },

  getCoinConfList(data) {
    return http.get({
      url: "/admin/mortgage/coinConfList",
      data,
    });
  },
  editCoinConfig(data) {
    return http.post({
      url: "/admin/mortgage/editCoinConfig",
      data,
      dataType: "form",
    });
  },

  getPreceptList(data) {
    return http.get({
      url: "/admin/mortgage/preceptList",
      data,
    });
  },

  preceptStatus(data) {
    return http.post({
      url: "/admin/mortgage/preceptStatus",
      data,
      dataType: "form",
    });
  },
  preceptEdit(data) {
    return http.post({
      url: "/admin/mortgage/preceptEdit",
      data,
      dataType: "form",
    });
  },
  getAccountList(data) {
    return http.get({
      url: "/admin/mortgageOrder/account",
      data,
    });
  },
  getPreceptDataList(data) {
    return http.get({
      url: "/admin/mortgageOrder/preceptData",
      data,
    });
  },
  getOrderList(data) {
    return http.get({
      url: "/admin/mortgageOrder/orderList",
      data,
    });
  },

  getBlastList(data) {
    return http.get({
      url: "/admin/mortgageOrder/blastList",
      data,
    });
  },
  getOrderDetail(data) {
    return http.get({
      url: "/admin/mortgageOrder/orderDetail",
      data,
    });
  },

  auditOrder(data) {
    return http.post({
      url: "/admin/mortgageOrder/auditOrder",
      data,
      dataType: "form",
    });
  },
  remarkOrder(data) {
    return http.post({
      url: "/admin/mortgageOrder/remarkOrder",
      data,
      dataType: "form",
    });
  },

  //全币种合约
  getContractAccountList(data) {
    return http.get({
      url: "/admin/contract/order/account",
      data,
    });
  },
  //项目方币种管理
  getGeneralList(data) {
    return http.get({
      url: "/admin/contract/general/getConfigList",
      data,
    });
  },

  //真正的项目方管理
  getpartnerProjectList(data) {
    return http.get({
      url: "/admin/contract/general/getProjectList",
      data,
    });
  },

  //获取全币种合约配置
  async getGeneralConfig(data) {
    return http.get({
      url: "/admin/contract/general/getConfig",
      data,
      // dataType:'form'
    });
  },

  getGeneralIndexCoinConfig(data) {
    return http.get({
      url: "/admin/contract/general/indexCoinConfig",
      data,
    });
  },

  updateIndexCoinFeeRate(data) {
    return http.post({
      url: "/admin/contract/general/updateConfigIndexCoinConfig",
      data,
      dataType: "form",
    });
  },

  //获取支持的指数币种集合
  getIndexCoins(data) {
    return http.get({
      url: "/admin/contract/general/indexCoins",
      data,
      // dataType:'form'
    });
  },

  addConfigIndexCoin(data) {
    return http.post({
      url: "/admin/contract/general/addConfigIndexCoin",
      data,
      dataType: "form",
    });
  },

  //上下架修改
  generalUpOrDown(data) {
    return http.post({
      url: "/admin/contract/general/updateConfigStatus",
      data,
      dataType: "form",
    });
  },
  udpateProjectStatus(data) {
    return http.post({
      url: "/admin/contract/general/updateProjectStatus",
      data,
      dataType: "form",
    });
  },

  updateConfigIndexCoin(data) {
    return http.post({
      url: "/admin/contract/general/updateConfigIndexCoin",
      data,
      dataType: "form",
    });
  },
  //超级合约开交易
  updateConfigOpen(data) {
    return http.post({
      url: "/admin/contract/general/updateConfigOpen",
      data,
      dataType: "form",
    });
  },

  //超级合约 币种 上下架
  updateCoinConfigStatus(data) {
    return http.post({
      url: "/admin/contract/general/updateConfigStatus",
      data,
      dataType: "form",
    });
  },

  //全币种合约配置修改
  generalUpdagteConfig(data) {
    return http.post({
      url: "/admin/contract/general/updateConfig",
      data,
      dataType: "form",
    });
  },

  //全币种合约配置新增
  generalAddConfig(data) {
    return http.post({
      url: "/admin/contract/general/addConfig",
      data,
      dataType: "form",
    });
  },

  updateProejct(data) {
    return http.post({
      url: "/admin/contract/general/updateProejct",
      data,
      dataType: "form",
    });
  },

  //超级合约项目方新增
  generalAddProejct(data) {
    return http.post({
      url: "/admin/contract/general/addProejct",
      data,
      dataType: "form",
    });
  },

  getContractOrderList(data) {
    return http.get({
      url: "/admin/contract/order/getConfigList",
      data,
      // dataType:'form'
    });
  },

  //项目方持仓明细
  getProjectList2(data) {
    return http.get({
      url: "/admin/contract/order/getProjectList",
      data,
      // dataType:'form'
    });
  },

  //交易持仓明细
  getHoldOrderList(data) {
    return http.get({
      url: "/admin/contract/order/orders",
      data,
    });
  },

  //代理商
  selectAgentStatement(data) {
    return http.get({
      url: "/admin/agent/agentStatement",
      data,
    });
  },
  getAgentTotalAmount(data) {
    return http.get({
      url: "/admin/agent/agentTotalAmount",
      data,
    });
  },
  selectAgentRebate(data) {
    return http.get({
      url: "/admin/agent/agentBouns",
      data,
    });
  },
  agentInviteRecord(data) {
    return http.get({
      url: "/admin/agent/agentBounsDetail",
      data,
    });
  },
  getCheckDetail(data) {
    return http.get({
      url: "/admin/agent/feeBounsUserDetail",
      data,
    });
  },
  getAgentInviteRecord(data) {
    return http.get({
      url: "/admin/agent/agentInviteRecord",
      data,
    });
  },

  exportTransaction(data) {
    return http.post({
      url: "/admin/contract/order/export",
      data,
      dataType: "form",
      responseType: "blob",
    });
  },

  contractStatisticProfit(data) {
    return http.get({
      url: "/admin/contract/general/profit",
      data,
    });
  },
  getOrderProjectAccount(data) {
    return http.get({
      url: "/admin/contract/order/projectAccount",
      data,
    });
  },
  getUserWallet(id) {
    return http.get({
      url: "/admin/workorder/findByUse/wallet",
      data: {
        userId: id,
      },
    });
  },
};
